/* eslint-disable import/no-duplicates */
import { format as formatFunc } from "date-fns";
import { fi } from "date-fns/locale";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { localeMap } from "~/components/App";

export type UseDateFormatterReturn = ({
  date,
  format,
  options,
}: DateFormatterArgs) => string;

interface DateFormatterArgs {
  date: Date | number;
  format?: string;
  options?: {
    locale?: Locale;
    weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    firstWeekContainsDate?: number;
    useAdditionalWeekYearTokens?: boolean;
    useAdditionalDayOfYearTokens?: boolean;
  };
}

export function useDateFormatter(): UseDateFormatterReturn {
  const {
    i18n: { language },
  } = useTranslation();
  const dateFormatter = useCallback(
    ({ date, format = "Pp", options }: DateFormatterArgs) => {
      if (!date) return "";
      return formatFunc(date, format, {
        ...options,
        locale: localeMap[language] ?? fi,
      });
    },
    [language],
  );
  return dateFormatter;
}
